import React from "react";
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import Box from "@material-ui/core/Box";
import TwitterIcon from "@material-ui/icons/Twitter";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import FacebookIcon from "@material-ui/icons/Facebook";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    socialNav: {
      height: "3rem",
      marginTop: "10px",
      marginBototm: "10px",
    },
    socialNavItem: {
      backgroundColor: theme.palette.primary.main,
      color: "#fff",
      border: "2px solid #dde2e5",
      borderRadius: "50%",
      textDecoration: "none",
      width: "40px",
      height: "40px",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      marginLeft: "5px",
      marginRight: "5px",
      "&:hover": {
        backgroundColor: theme.palette.primary.dark,
      },
    },
  })
);

export default function SocialBanner() {
  const classes = useStyles();

  return (
    <Box
      className={classes.socialNav}
      justifyContent="center"
      display="flex"
      alignItems="center"
    >
      <a
        className={classes.socialNavItem}
        target="_blank"
        href="https://www.linkedin.com/showcase/hedge-fund-alert/"
        rel="noreferrer"
      >
        <LinkedInIcon />
      </a>
      <a
        className={classes.socialNavItem}
        target="_blank"
        href="http://www.twitter.com/HFAlert"
        rel="noreferrer"
      >
        <TwitterIcon />
      </a>
    </Box>
  );
}
